var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKpmgReopenConfirm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90.161,
    height: 71.812,
    viewBox: "0 0 90.161 71.812"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".kpmg-reopen-confirm_svg__cls-2,.kpmg-reopen-confirm_svg__cls-3,.kpmg-reopen-confirm_svg__cls-5{fill:none}.kpmg-reopen-confirm_svg__cls-2,.kpmg-reopen-confirm_svg__cls-3{stroke:#fff;stroke-linecap:round;stroke-width:1.6px}.kpmg-reopen-confirm_svg__cls-3{stroke-linejoin:round}.kpmg-reopen-confirm_svg__cls-4{stroke:none}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kpmg-reopen-confirm_svg__ICN_Modal_confirmare_Cere_Redeschiderea-_Acces_Enabled",
    "data-name": "ICN_Modal confirmare Cere Redeschiderea- Acces_Enabled",
    transform: "translate(-942.919 -396.388)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "kpmg-reopen-confirm_svg__Path_948",
    "data-name": "Path 948",
    d: "M44.5 13.39a4 4 0 016.929 0l41.11 63.81a4 4 0 01-3.465 6H6.926a4 4 0 01-3.465-6z",
    transform: "translate(940 385)",
    fill: "#eaaa00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-reopen-confirm_svg__ICN_Redeschide_Enabled",
    transform: "translate(1099 1674.409)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kpmg-reopen-confirm_svg__Rectangle_255",
    "data-name": "Rectangle 255",
    className: "kpmg-reopen-confirm_svg__cls-2",
    transform: "translate(-121 -1237.419)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "kpmg-reopen-confirm_svg__cls-4",
    width: 19.554,
    height: 16.571,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "kpmg-reopen-confirm_svg__cls-5",
    x: 0.8,
    y: 0.8,
    width: 17.954,
    height: 14.971,
    rx: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-reopen-confirm_svg__Group_706",
    "data-name": "Group 706",
    transform: "translate(-113.598 -1232.993)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kpmg-reopen-confirm_svg__Ellipse_164",
    "data-name": "Ellipse 164",
    className: "kpmg-reopen-confirm_svg__cls-3",
    transform: "translate(0 4.014)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "kpmg-reopen-confirm_svg__cls-4",
    cx: 2.408,
    cy: 2.408,
    r: 2.408
  }), /*#__PURE__*/React.createElement("circle", {
    className: "kpmg-reopen-confirm_svg__cls-5",
    cx: 2.408,
    cy: 2.408,
    r: 1.608
  })), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-reopen-confirm_svg__Line_82",
    "data-name": "Line 82",
    className: "kpmg-reopen-confirm_svg__cls-2",
    transform: "translate(2.408)",
    d: "M0 0v4.816"
  })), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-reopen-confirm_svg__Path_825",
    "data-name": "Path 825",
    className: "kpmg-reopen-confirm_svg__cls-3",
    d: "M-118.058-1238.483v-3.33a5.5 5.5 0 015.449-5.4 5.29 5.29 0 015.449 4.127",
    transform: "translate(1.283 1.699)"
  })))));
}

export default SvgKpmgReopenConfirm;